import React from 'react';
import { Link } from 'react-router-dom';
import RoutingService from '../../logic/services/RoutingService';
import { history } from 'WebsiteApp/logic/store/AppStore';

class AppLink extends React.Component {

  render() {
    let additionalProps = {};
    if (this.props.noScroll) {
      additionalProps.onClick = (e) => { e.preventDefault(); RoutingService.preventScroll(); history.push(this.props.to); }
    }

    if(this.props.toTop) {
      additionalProps.onClick = (e) => { e.preventDefault(); RoutingService.toTop(); history.push(this.props.to); }
    }

    let props = {...this.props};
    delete props.noScroll;

    return <Link {...props} {...additionalProps}>{this.props.children}</Link>
  }
}

export default AppLink;



// WEBPACK FOOTER //
// ./src/components/routing/AppLink.js